import React from 'react';

import './AboutUsPage.scss';

const AboutUs = () => {
  return (
    <>
      <section className="about-us-section">
        <h3>درباره مجمع هماهنگی اصناف کشاورزی استان مازندران </h3>
        <p>
          نظام صنفی کشاورزی، تشکلی فراگیر و مردم نهاد مرکب از بهره‌برداران و
          تولیدکنندگان زیربخش‌های مختلف کشاورزی به منظور سازماندهی، نظم بخشی و
          دفاع از حقوقان فعالان بخش کشاورزی با بهره‌گیری از پتانسیل بالقوه
          صاحبان این حوزه مردمی است که مدیران و ارکان آن تماما از جنس فعالان بخش
          و مستقیما از سوی کشاورزان و دامداران بخش‌ها و شهرستان‌های سراسر کشور
          انتخاب می‌شوند. این نظام به دلیل خاستگاه اصلی خود و با استفاده از کلیه
          ابزار‌های قانونی و سرمایه ارزشمند اجتماعی، بدنبال ترسیم نقشه راهی در
          جهت رفع موانع "توسعه پایدار کشاورزی" است، توسعه‌ای که پایه و اساس
          تامین امنیت غذایی جامعه، اشتغال پایدار و رفاه اجتماعی خانواده بیست و
          چند میلیونی کشاورزی کشور را در بر دارد. در این رهگذر با توجه در درک
          کامل مشکلات ریشه‌ای و گره‌گاه‌های اساسی اقتصاد کشاورزی، رسالت آرمانی
          این نظام، در کنار سازمان‌دهی و هویت بخشی به کلیه فعالان زنجیره
          عرضه(ارزش) محصولات کشاورزی، "حرکت به سمت کشاورزی نوین و هدفمند" از
          طریق ایجاد و تکمیل زنجیره‌های تامین و تولید، با هدف افزایش سهم
          کشاورزان و بهره‌برداران از زنجیره ارزش محصولات کشاورزی، حذف واسطه‌گری
          غیر ضرور و حفظ حقوق مصرف‌کنندگان بوده، بدیهی است از جمله مهمترین
          حلقه‌های بنیادین این راهبرد، فراهم آوردن زمینه‌های نرم افزاری و سخت
          افزاری برای توسعه زنجیره ارزش محصولات با نگاه چشم انداز کوتاه کردن
          فاصله میان تولیدکنندگان و مصرف‌کنندگان، تولید محصول سالم و بازار‌محور
          .و افزایش بهره‌وری در بخش کشاورزی است
        </p>
        <p>
          مجمع هماهنگی اصناف کشاورزی استان مازندران به عنوان یکی از پیشرو ترین نظام‌های
          صنفی سراسر کشور، با طراحی و راه‌اندازی سامانه جامع بهره‌برداران
          کشاورزی (سبک) و هبه آن به نظام صنفی کشاورزی کشور، گام بسیار بلندی در
          راستای دستیابی به کاملترین و دقیق‌ترین بانک اطلاعاتی بهره‌برداران
          کشاورزان ایران برداشته است. مدیریت هوشمند بازار و تغییر رویکرد تولید
          محصولات کشاورزی از وضعیت سنتی به سمت توسعه فعالیت‌های بازار محور،
          اقدام اساسی دیگری در زمینه اصلاح زنجیره ارزش محصولات کشاورزی است،
          راهبرد بی نظیری که با طراحی و پایه گذاری سامانه (( دهقونیکا )) به
          همراه تمهیدات کاملا تخصصی و حرفهای در ابعاد گوناگون، استاندارد‌سازی،
          کدینگ و برندینگ محصولات کشاورزی، مدیریت یکپارچه زنجیره تولید و توسعه
          .تولیدات سالم و ارگانیک را هدف قرار داده است
        </p>
        <p>
          سامانه سبک که مطابق بند 18 مصوبه شورای مرکزی مورخ 20/11/1395 به عنوان
          سامانه ملی تحت وب نظام صنفی کشاورزی انتخاب و بر اساس صورتجلسه فی ما
          بین نظام کشور و نظام صنفی استان مازندران در مورخ 10/03/1396 به نظام
          صنفی کشاورزی کشور هبه گردیده، پس از تایید مرکز فناوری اطلاعات و
          ارتباطات وزرات جهاد کشاورزی در تاریخ 22/07/1399 در اولین جلسه هیأت
          عالی نظارت بر اصناف کشاورزی رونمایی شده و قابل بهره‌برداری توسط
          .کشاورزان و تولید‌کنندگان بخش کشاورزی کشور می‌باشد
        </p>
      </section>
    </>
  );
};
export  {AboutUs};
